<template>
    <div class="row h-100 justify-content-center align-items-center bg-info">
        <div class="col-sm-8 col-11">
            <h1>Seleccione la palabra o frase que lo describe mejor a usted.</h1>
            <table class="table table-bordered mt-4">
                <tbody>
                    <tr>
                        <td class="p-4 w-50" @click="set(page[0].value)">{{ page[0].question }}</td>
                        <td class="p-4 w-50" @click="set(page[1].value)">{{ page[1].question }}</td>
                    </tr>
                    <tr>
                        <td class="p-4 w-50" @click="set(page[2].value)">{{ page[2].question }}</td>
                        <td class="p-4 w-50" @click="set(page[3].value)">{{ page[3].question }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import router from "../router";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
export default {
    props: ["company", "number"],
    data() {
        return {
            questions: [
                [
                    {
                        value: 3,
                        question: "Reportero",
                    },
                    {
                        value: 0,
                        question: "Futurista",
                    },
                    {
                        value: 1,
                        question: "Realista",
                    },
                    {
                        value: 2,
                        question: "Coordinador",
                    },
                ],
                [
                    {
                        value: 2,
                        question: "Orientado a las personas",
                    },
                    {
                        value: 3,
                        question: "Concentrado en los detalles",
                    },
                    {
                        value: 1,
                        question: "Enfocado en los resultados",
                    },
                    {
                        value: 0,
                        question: "Pensamiento progresista",
                    },
                ],
                [
                    {
                        value: 0,
                        question: "Soñador",
                    },
                    {
                        value: 1,
                        question: "Ejecutor",
                    },
                    {
                        value: 3,
                        question: "Planificador",
                    },
                    {
                        value: 2,
                        question: "Pacifista",
                    },
                ],
                [
                    {
                        value: 1,
                        question: "Decidido",
                    },
                    {
                        value: 0,
                        question: "Inspirador",
                    },
                    {
                        value: 3,
                        question: "Constante",
                    },
                    {
                        value: 2,
                        question: "Considerado",
                    },
                ],
                [
                    {
                        value: 1,
                        question: "Cumple con las fechas limites",
                    },
                    {
                        value: 2,
                        question: "Une a las personas",
                    },
                    {
                        value: 3,
                        question: "Mantiene todo en marcha",
                    },
                    {
                        value: 0,
                        question: "Tiene sentido de misión",
                    },
                ],
                [
                    {
                        value: 0,
                        question: "Dramático",
                    },
                    {
                        value: 3,
                        question: "Curioso",
                    },
                    {
                        value: 2,
                        question: "Relajado",
                    },
                    {
                        value: 1,
                        question: "Enfocado",
                    },
                ],
                [
                    {
                        value: 3,
                        question: "Sabe cómo se deben hacer las cosas",
                    },
                    {
                        value: 1,
                        question: "Sabe lo que hay que hacer",
                    },
                    {
                        value: 0,
                        question: "Sabe dónde quiere estar",
                    },
                    {
                        value: 2,
                        question: "Sabe qué preguntas hacer",
                    },
                ],
                [
                    {
                        value: 3,
                        question: "Revisa los métodos",
                    },
                    {
                        value: 0,
                        question: "Se anticipa a los problemas",
                    },
                    {
                        value: 1,
                        question: "Resuelve problemas",
                    },
                    {
                        value: 2,
                        question: "Soluciona conflictos",
                    },
                ],
                [
                    {
                        value: 1,
                        question: "Obtiene resultados",
                    },
                    {
                        value: 3,
                        question: "Se asegura de dar los pasos correctos",
                    },
                    {
                        value: 2,
                        question: "Asegura el consenso",
                    },
                    {
                        value: 0,
                        question: "Se enfoca en los resultados",
                    },
                ],
                [
                    {
                        value: 0,
                        question: "Carismático",
                    },
                    {
                        value: 1,
                        question: "Preparado",
                    },
                    {
                        value: 2,
                        question: "Despreocupado",
                    },
                    {
                        value: 3,
                        question: "Alerta",
                    },
                ],
            ],
            ...mapGetters(["getAnswers", "getUser"]),
        };
    },
    computed: {
        page: function () {
            return this.questions[this.number];
        },
    },
    methods: {
        set(answer) {
            this.setAnswer(answer);
            if (this.number < 9) {
                router.push({
                    name: "Questions",
                    params: {
                        number: parseInt(this.number) + 1,
                        company: this.company,
                    },
                });
            } else {
                axios
                    .post(
                        "https://api.tocinn.com/api/profiles/" +
                            this.company +
                            "/results",
                        {
                            user: this.getUser(),
                            answers: this.getAnswers(),
                        }
                    )
                    .then(() => {
                        router.push({ name: "Results" });
                    })
                    .catch((err) => {
                        console.log(err);
                        alert("Hubo un error al guardar tus resultados");
                    });
            }
        },
        ...mapActions(["setAnswer"]),
    },
};
</script>
<style>
td {
    cursor: pointer;
    font-size: 20px;
}
</style>
